var map = {
	"./originalkinesio.jpg": "e700",
	"./originalktape.jpg": "d523",
	"./originalmaso.jpg": "62fc",
	"./originalosteo.jpg": "09a3",
	"./originalplantillas.jpg": "eafe",
	"./originalrpg.jpg": "1e06",
	"./smallkinesio.jpg": "9693",
	"./smallktape.jpg": "b5ea",
	"./smallmaso.jpg": "2ad8",
	"./smallosteo.jpg": "cd4a",
	"./smallplantillas.jpg": "fe5a",
	"./smallrpg.jpg": "1ef0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a531";